export const LOADED = 'LOADED'
export const SET_MENU_OPEN = 'SET_MENU_OPEN'
export const IS_SAMPLE = 'IS_SAMPLE'
export const SET_FULLSCREEN_IMG_VIEWER_OPTIONS = 'SET_FULLSCREEN_IMG_VIEWER_OPTIONS'
export const SET_PAGE_TRANSITIONING = 'SET_PAGE_TRANSITIONING'
export const SET_SEARCH_OPEN = 'SET_SEARCH_OPEN'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const SET_SEARCH_OPTIONS = 'SET_SEARCH_OPTIONS'
export const UPDATE_VIEWPORT_SIZE = 'UPDATE_VIEWPORT_SIZE'
export const UPDATE_NUMBER_ITEM_DISPLAY = 'UPDATE_NUMBER_ITEM_DISPLAY'
export const UPDATE_AUDIO_PLAYER_STATE = 'UPDATE_AUDIO_PLAYER_STATE'
export const SET_LIST_TYPE = 'SET_LIST_TYPE'
export const RESULTS_LIMIT = 100
